import React from "react";
import PropTypes from "prop-types";

const AIStatusPill = ({ status, error }) => {
  const statusMap = {
    success: { color: "bg-green-100 text-green-800", label: "success" },
    failed: { color: "bg-red-100 text-red-800", label: "failed" },
    pending: { color: "bg-amber-100 text-amber-800", label: "ai processing" },
    cancelled: { color: "bg-gray-100 text-gray-800", label: "cancelled" },
    canceled: { color: "bg-gray-100 text-gray-800", label: "cancelled" },
  };
  const color = statusMap[status]?.color || "bg-gray-100 text-gray-800";
  const label = statusMap[status]?.label || status || "idle";

  return (
    <div className="flex items-center gap-2">
      <span className={`inline-block px-2 py-1 rounded-full text-xs ${color}`}>
        {label}
      </span>
      {status === "failed" && !!error && (
        <span className="text-xs text-red-600" title={error}>
          {String(error).slice(0, 120)}
          {String(error).length > 120 ? "…" : ""}
        </span>
      )}
    </div>
  );
};

AIStatusPill.propTypes = {
  status: PropTypes.string,
  error: PropTypes.any,
};

export default AIStatusPill;
